// extracted by mini-css-extract-plugin
export default {"empty":"Report_empty__J-YYY","placeHolderShimmer":"Report_placeHolderShimmer__RK7n+"};